export { default } from "./AspectRatio";
export * from "./AspectRatio";
